import { Geotag, Log } from '../models';

/**
 *
 * @param {Log} log
 * @param {Geotag[]} geotags
 * @returns {boolean}
 */
function geotagDoNotExistOnLog(log, geotags = []) {
  for (const geotag of geotags) {
    const time = geotag.ixDatetime % 10000;

    let logExists = false;
    for (let counter = 1; counter <= 12; counter++) {
      if (log[`BIO${counter}`] === 0) break;
      if (time === log[`BIO${counter}`]) {
        logExists = true;
        break;
      }
    }

    if (!logExists) return true;
  }

  return false;
}

export default geotagDoNotExistOnLog;
